import axios from "axios";
import {ApolloClient, HttpLink, InMemoryCache, gql} from '@apollo/client';

import {removeUserSignUpErrors, setUserSignUpError} from "./AuthErrorsActions";
import {signUpTypes} from "./AuthActionsTypes/SignUpActionsTypes";

export const requestUserSignUp = () => {
    return {
        type: signUpTypes.SIGN_UP_REQUEST,
    };
};

export const successUserSignUp = (data) => {
    return {
        type: signUpTypes.SIGN_UP_SUCCESS,
        accessToken: data.accessToken,
        verified: data.verified,
    };
};

export const failureUserSignUp = (data) => {
    return {
        type: signUpTypes.SIGN_UP_FAILURE,
    };
};

export const userSignUp = (user) => {
    return (dispatch, getState) => {
        dispatch(removeUserSignUpErrors());
        dispatch(requestUserSignUp());

        // TODO: Replace with ..
        const USER_SIGN_UP_API = "https://api.scoutafrique.com/api/auth/register";

        return axios.post(USER_SIGN_UP_API, user)
            .then(response => {
                const data = response.data;
                const {accessToken} = data;

                localStorage.setItem('jwt', accessToken);
                dispatch(successUserSignUp(data));
            }).catch(error => {

                dispatch(failureUserSignUp());
                dispatch(setUserSignUpError(error));

                return Promise.reject(setUserSignUpError(error));
            });
    };
};

export const fetchTeams = searchText => dispatch => {

};
